import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeIcon } from '@model/icon.model';
import { ICardList } from 'src/app/model/card-list.model';

@Component({
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
})
export class CardListComponent implements OnInit {
  typeIcon = TypeIcon;
  @Input() cardListConfig: ICardList[] = [];

  constructor() {}

  ngOnInit(): void {}
}
